import { FILTER_TYPE_NAMES } from '../filterTypes';
import valueIn from '../../utils/valueIn';

export const FILTER_TYPES = {
  // TODO: remove binary_bucket (do we even need this?)
    BINARY_BUCKET: {
        TRUE: '@_TRUE_@',
        FALSE: '@_FALSE_@',
    },
    [FILTER_TYPE_NAMES.BOOLEAN]: FILTER_TYPE_NAMES.BOOLEAN,
    [FILTER_TYPE_NAMES.SEGMENTS]: FILTER_TYPE_NAMES.SEGMENTS,
    [FILTER_TYPE_NAMES.PRICE]: FILTER_TYPE_NAMES.PRICE,
    [FILTER_TYPE_NAMES.DISTANCE]: FILTER_TYPE_NAMES.DISTANCE,
    [FILTER_TYPE_NAMES.GUEST_RATING]: FILTER_TYPE_NAMES.GUEST_RATING,
};

const DEFAULT_RESET = (currentState) => {
    const resetState = {};
    currentState.forEach((option, key) => {
        resetState[key] = {
            name: valueIn(option, 'name'),
            value: false,
        };
    });

    return resetState;
};

export default function Filter(f) {
    const {
    id,
    caId,
    analyticsName,
    queryKey,
    type,
    bucketify = false,
    toQuery,
    fromQuery,
    isFilterActive,
    decorateFinalState = false,
    reset = DEFAULT_RESET,
    onFilterPanelClose,
    onFilterValueUpdate,
  } = f(FILTER_TYPES);

    return {
        id,
        caId,
        analyticsName,
        queryKey,
        type,
        bucketify,
        toQuery,
        fromQuery,
        isFilterActive,
        decorateFinalState,
        reset,
        onFilterPanelClose,
        onFilterValueUpdate,
        isInvalid: !id || !toQuery || !fromQuery || !queryKey || !type,
    };
}
